import React from 'react';
import { Typography, Space, Button, Col, Row, } from 'antd';
import { ArrowLeftIcon } from '@phosphor-icons/react';

// Local PageHeader — replaces @ant-design/pro-layout PageHeader (removed in antd 6).
// Supports: title, subTitle, extra, onBack, children (content area), className, ghost (ignored, for compat).
const PageHeader = ({
    title,
    subTitle,
    extra,
    onBack,
    children,
    className = "bg-white",
    ...props
}) => (
    <Row justify={"center"} align={"middle"} >
        <Col span={24} className={`bg-white ${className}`} data="header-test">
            <div className="p-2">
                <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }} wrap>
                    <Space align="start" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                        {onBack && (
                            <Button
                                onClick={onBack} type="text"
                                icon={<ArrowLeftIcon size={20} />}
                            />
                        )}
                        <Space orientation="vertical" size={0}>
                            {title && (
                                <Typography.Title level={4} style={{ margin: 0 }}>
                                    {title}
                                </Typography.Title>
                            )}
                            {subTitle && (
                                <Typography.Text type="secondary">{subTitle}</Typography.Text>
                            )}
                        </Space>
                    </Space>
                    {extra && <Space>{extra}</Space>}
                </Space>
                {children}
            </div>
        </Col>
    </Row>
);

export default PageHeader;
